import { render } from "./PaypalEmail.vue?vue&type=template&id=583e7bc8&scoped=true&ts=true"
import script from "./PaypalEmail.vue?vue&type=script&lang=ts"
export * from "./PaypalEmail.vue?vue&type=script&lang=ts"

import "./PaypalEmail.vue?vue&type=style&index=0&id=583e7bc8&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-583e7bc8"]])

export default __exports__